// extracted by mini-css-extract-plugin
export default {"title":"IntelligenceSolutionItem_title__UJjTc","body":"IntelligenceSolutionItem_body__OW+zg","products":"IntelligenceSolutionItem_products__cqRu+"};